/**
 * トランジション時の前面レイヤー
 */
let EventEmitter = require("events").EventEmitter;
import './PolyfillTransitionEnd';
import AnyStore from './AnyStore';
import commonKV from './commonKV';

export default class PageTransition extends EventEmitter {
  /**
   * コンストラクタ
   */
  constructor() {
    super();

    // クラス名
    this.name = 'PageTransition';

    this.bindOutEnd = null;
    this.bindInEnd = null;
    this.isTransition = false;

    // 前面に表示するてイヤー
    this.elOverlayA = document.getElementById('p-overlay--a');
    this.elLoading = document.getElementById('p-loading');

    this.init();
  }

  /**
   * 初期化
   */
  init() {
    // リンク（aタグ）をクリックした時の処理
    document.addEventListener('click', this.onLink.bind(this), true);

    // 共通下層KV
    this.commonKV = new commonKV();

    // イベント発火
    this.emit("READY");
  }

  /**
   * PageTransition単体で開始する場合
   */
  start() {
    this.transitionOut();
  }

  /**
   * 前面のレイヤーが外に出る
   */
  transitionOut(e) {
    if (e) e.preventDefault();

    // 全体をvisible
    //document.body.style.visibility = 'visible';
    document.getElementById('js-scroller').style.visibility = 'visible';

    // transitionEndイベント
    this.bindOutEnd = this.transitionOutEnd.bind(this);
    this.elOverlayA.addEventListener(window.transitionEnd, this.bindOutEnd);

    // css transition
    TweenMax.set(this.elOverlayA, {className: '+=transition-out'});

    // ローディング
    TweenMax.set(this.elLoading, {className: '-=is-hide'});
    TweenMax.set(this.elLoading, {className: '+=transition-out'});

    // 共通下層KV
    this.commonKV.start();

    // イベント発火
    this.emit("TRANSITION_OUT");
  }

  transitionOutEnd() {
    // イベントリスナー削除
    this.elOverlayA.removeEventListener(window.transitionEnd, this.bindOutEnd);
    this.bindOutEnd = null;

    // レイヤーを画面の下に移動しておく
    TweenMax.set(this.elOverlayA, {className: '-=transition-out'});
    TweenMax.set(this.elOverlayA, {className: '+=transition-before'});

    // ローディング
    TweenMax.set(this.elLoading, {className: '-=transition-out'});
    TweenMax.set(this.elLoading, {className: '+=transition-before'});
    TweenMax.set(this.elLoading, {className: '+=is-hide'});
  }

  /**
   * 前面のレイヤーが入ってくる
   */
  transitionIn(e) {
    if (e) e.preventDefault();

    // transitionEndイベント
    this.bindInEnd = this.transitionInEnd.bind(this);
    this.elOverlayA.addEventListener(window.transitionEnd, this.bindInEnd);

    // ローディング
    TweenMax.set(this.elLoading, {className: '-=is-hide'});
    TweenMax.set(this.elLoading, {className: '+=transition-in'});

    // レイヤーを画面の上に移動する
    // ※ tarnsitionendイベントが発火しないので修正
    //TweenMax.set(this.elOverlayA, {className: '+=transition-in'});
    this.elOverlayA.className += ' transition-in';

    // イベント発火
    this.emit("TRANSITION_IN");
  }

  transitionInEnd() {
    // イベントリスナー削除
    this.elOverlayA.removeEventListener(window.transitionEnd, this.bindInEnd);
    this.bindInEnd = null;

    // URLへ遷移する
    location.href = this.linkUrl;
  }

  /**
   * リンク押下で実行
   * @param {string}url リンク先URL
   */
  onLink(e) {
    // 以降はPJAX遷移なのでイベントキャンセル
    if (this.isTransition) return e.preventDefault();
    //if (this.isLinking) return e.preventDefault();
    this.isLinking = true;

    // aタグを取得する
    let el = e.target;
    while (el && !AnyStore.getHref(el)) {
      el = el.parentNode;
    }

    // aタグではない
    const url = AnyStore.getHref(el);
    if (!el || !url) {
      this.isLinking = false;
      return false;
    }

    // #なのでtrueならリンク先が現ページと同じ
    if (AnyStore.checkMyself(el, url)) {
      this.isLinking = false;
      return false;
    }

    // trueなら外部リンク
    if (AnyStore.checkExternal(el, url)) {
      this.isLinking = false;
      return false;
    }

    // URLが全く同じは処理を止める
    if (location.href.replace(/\/$/, '') === el.href) {
      e.preventDefault();
      e.stopPropagation();
      //this.commonClass.Gnav.closeNav();
      this.isLinking = false;
      return false;
    }

    // 以降はPJAX遷移なのでイベントキャンセル
    e.stopPropagation();
    e.preventDefault();

    // URL書き換え：新ページページ遷移
    this.linkUrl = url;
    this.transitionIn();
    this.isLinking = false;
  }
}
